
import React, { forwardRef, useEffect, useState, useMemo } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

const BugCrowdMappingForm = forwardRef(function BugCrowdMappingForm(props, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { programId, programName } = props.record;
      return [{id: programId, name: programName }]
    }
    return [];
  });

  useEffect(() => {
      const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
      promise.then((response) => {
        const { projects } = response;
        setProjects(projects);
      }).catch((err)=>{
        message.error('Problem fetching programs')
      });
      
      return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = useMemo(() => (config) => {
    const { programId } = config;
    return {
      programId,
      programName: projects.find(project => project.id === programId)?.name
    };
  }, [projects])

  const extraFields = useMemo(() => ([{
      name: 'programId',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Program Name',
      options: projects.map(option => {
        const { label = option.name, value = option.id } = option;
        return { label, value }
      }),
      required: true,
      props: {
        autoFocus: true
      }
    }
  ]), [projects]);

  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default BugCrowdMappingForm;
